import Store from '@/store'
import Grid from "@/components/grid/grid.js";
import { showErrorSnackbar } from "@/utilities/snackbar.js";
import i18n from "@/i18n";
import { DateUtilities } from '@/utilities/dates';

export default class Ast {

  static EPSILON = 0.0001;

  static functions = new Set([
    'eq',
    'notEq',
    'g',
    'ge',
    'if',
    'min',
    'max',
    'cat',
    'ifEqual',
    'ifEqualOrHigher',
    'ifEqualOrLessWithFirstArgAbs',
    'ppmt',
    'ipmt',
    'ipmtWithNaNReturn',
    'sum',
    'alternateSum',
    'minArg',
    'maxArg',
    'avg',
    'maxArgWithoutZeros',
    'minArgWithoutZeros',
    'avgWithoutZeros',
    'dsrcSolver',
    'size',
    'checkStore',
    'ifError',
    'ifErrorWithNullOrInfinityOrUndefined',
    'ifErrorManagedIndeterminateZeroDividedZero',
    'ifErrorLikeExcel',
    'ifErrorManagedIndeterminateZeroDividedZeroWithGreaterCondition',
    'logTest',
    'invisibleSixthAndSeventhTable',
    'sumWithNullArgArray',
    'ifHigher',
    'searchLeasingYear',
    'produceGrossRateKeyString',
    'yearFrac',
    'roundDown',
    'dateStartYear',
    'dateEndYear',
    'dateAddDays',
    'dateDiff',
    'dateEq',
    'dateG',
    'dateGe',
    'dateMax',
    'dateMin',
    'getReferenceDateBP',
    'int',
    'cumipmt',
    'cumprinc',
    'fv'
  ])

  static fn(op, args) {
    if (op == 'eq') return Ast.eq(args[0], args[1])
    if (op == 'notEq') return Ast.notEq(args[0], args[1])  
    if (op == 'g') return Ast.g(args[0], args[1])
    if (op == 'ge') return Ast.ge(args[0], args[1])
    if (op == 'if') return Ast.if(args[0], args[1], args[2])
    if (op == 'min') return Ast.min(args[0], args[1])
    if (op == 'max') return Ast.max(args[0], args[1])
    if (op == 'cat') return Ast.cat(args[0], args[1])
    if (op == 'ifEqual') return Ast.ifEqual(args[0], args[1], args[2], args[3])
    if (op == 'ifEqualOrHigher') return Ast.ifEqualOrHigher(args[0], args[1], args[2], args[3])
    if (op == 'ifHigher') return Ast.ifHigher(args[0], args[1], args[2], args[3])
    if (op == 'ifEqualOrLessWithFirstArgAbs') return Ast.ifEqualOrLessWithFirstArgAbs(args[0], args[1], args[2], args[3])
    if (op == 'ppmt') return Ast.ppmt(args[0], args[1], args[2], args[3], args[4], args[5])
    if (op == 'ipmt') return Ast.ipmt(args[0], args[1], args[2], args[3], args[4], args[5])
    if (op == 'ipmtWithNaNReturn') return Ast.ipmtWithNaNReturn(args[0], args[1], args[2], args[3], args[4], args[5])
    if (op == 'sum') return Ast.sum(args)
    if (op == 'alternateSum') return Ast.alternateSum(args)
    if (op == 'minArg') return Ast.minArg(args[0], args[1])
    if (op == 'maxArg') return Ast.maxArg(args[0], args[1])
    if (op == 'avg') return Ast.avg(args[0], args[1])
    if (op == 'minArgWithoutZeros') return Ast.minArgWithoutZeros(args)
    if (op == 'maxArgWithoutZeros') return Ast.maxArgWithoutZeros(args)
    if (op == 'avgWithoutZeros') return Ast.avgWithoutZeros(args)
    if (op == 'dsrcSolver') return Ast.dsrcSolver(args[0])
    if (op == 'size') return Ast.size(args)
    if (op == 'checkStore') return Ast.checkStore(args[0])
    if (op == 'ifError') return Ast.ifError(args[0], args[1], args[2])
    if (op == 'ifErrorWithNullOrInfinityOrUndefined') return Ast.ifErrorWithNullOrInfinityOrUndefined(args[0], args[1])
    if (op == 'ifErrorLikeExcel') return Ast.ifErrorLikeExcel(args[0], args[1])
    if (op == 'ifErrorManagedIndeterminateZeroDividedZero') return Ast.ifErrorManagedIndeterminateZeroDividedZero(args[0], args[1], args[2], args[3])
    if (op == 'ifErrorManagedIndeterminateZeroDividedZeroWithGreaterCondition') return Ast.ifErrorManagedIndeterminateZeroDividedZeroWithGreaterCondition(args[0], args[1], args[2], args[3], args[4], args[5])
    if (op == 'logTest') return Ast.logTest(args[0], args[1], args[2], args[3], args[4], args[5], args[6], args[7], args[8], args[9], args[10])
    if (op == 'invisibleSixthAndSeventhTable') return Ast.invisibleSixthAndSeventhTable(args[0], args[1], args[2], args[3], args[4])
    if (op == 'sumWithNullArgArray') return Ast.sumWithNullArgArray(args)
    if (op == 'searchLeasingYear') return Ast.searchLeasingYear(args)
    if (op == 'produceGrossRateKeyString') return Ast.produceGrossRateKeyString(args[0])
    if (op == 'yearFrac') return Ast.yearFrac(args[0], args[1], args[2])
    if (op == 'roundDown') return Ast.roundDown(args[0], args[1])
    if (op == 'dateStartYear') return Ast.dateStartYear(args[0])
    if (op == 'dateEndYear') return Ast.dateEndYear(args[0])
    if (op == 'dateAddDays') return Ast.dateAddDays(args[0], args[1])
    if (op == 'dateDiff') return Ast.dateDiff(args[0], args[1])
    if (op == 'dateEq') return Ast.dateEq(args[0], args[1])  
    if (op == 'dateG') return Ast.dateG(args[0], args[1])
    if (op == 'dateGe') return Ast.dateGe(args[0], args[1]) 
    if (op == 'dateMax') return Ast.dateMax(args[0], args[1])
    if (op == 'dateMin') return Ast.dateMin(args[0], args[1])
    if (op == 'getReferenceDateBP') return Ast.getReferenceDateBP()
    if (op == 'int') return Ast.int(args[0])
    if (op == 'cumipmt') return Ast.cumipmt(args[0],args[1],args[2],args[3],args[4],args[5])  
    if (op == 'cumprinc') return Ast.cumprinc(args[0],args[1],args[2],args[3],args[4],args[5])
    if (op == 'fv') return Ast.fv(args[0],args[1],args[2],args[3],args[4])
  }

  static eq(arg1, arg2) {
    return Math.abs(arg1 - arg2) < Ast.EPSILON ? 1 : 0
  }

  static notEq(arg1, arg2) {
    return Math.abs(arg1 - arg2) < Ast.EPSILON ? 0 : 1
  }

  static g(arg1, arg2) {
    return arg1 > arg2 ? 1 : 0
  }

  static ge(arg1, arg2) {
    return arg1 >= arg2 ? 1 : 0
  }

  static if(arg1, arg2, arg3) {
    return arg1 > 0 ? arg2 : arg3
  }

  static ifEqual(arg1, arg2, arg3, arg4) {
    return arg1 == arg2 ? arg3 : arg4
  }

  static ifEqualOrHigher(arg1, arg2, arg3, arg4) {
    return arg1 >= arg2 ? arg3 : arg4
  }

  static ifHigher(arg1, arg2, arg3, arg4) {
    return arg1 > arg2 ? arg3 : arg4
  }

  static ifEqualOrLessWithFirstArgAbs(arg1, arg2, arg3, arg4) {
    return Math.abs(arg1) <= arg2 ? arg3 : arg4
  }

  static ifError(arg1, arg2, arg3) {
    return arg1 != 0 ? arg2 : arg3
  }

  static ifErrorWithNullOrInfinityOrUndefined(arg1, arg2) {
    if (isNaN(arg1) || arg1 === null || arg1 === Infinity || arg1 === - Infinity) {
      return arg2;
    } else {
      return arg1
    }
  }

  static ifErrorLikeExcel(arg1, arg2) {
    if (isNaN(arg1) || arg1 === null || arg1 === Infinity || arg1 === - Infinity) {
      return arg2;
    } else {
      return arg1;
    }
  }

  static ifErrorManagedIndeterminateZeroDividedZero(arg1, arg2, arg3, arg4) {
    return !(arg1 == 0 && arg2 == 0) ? arg3 : arg4
  }

  static ifErrorManagedIndeterminateZeroDividedZeroWithGreaterCondition(arg1, arg2, arg3, arg4, arg5, arg6) {
    if (arg1 > 0) {
      return !(arg2 == 0 && arg3 == 0) ? arg4 : arg5
    } else {
      return arg6
    }
  }

  static min(arg1, arg2) {
    return arg1 > arg2 ? arg2 : arg1
  }

  static max(arg1, arg2) {
    return arg1 > arg2 ? arg1 : arg2
  }

  static cat(arg1, arg2) {
    return `${arg1}${arg2}`
  }

  static sum(argArray) {
    let flatArray = argArray.flat()
    let result = flatArray.reduce((a, b) => {
      return a + b
    }, 0)
    return result
  }

  static alternateSum(argArray) {
    let flatArray = argArray.flat();
    let result = 0;
    for (let index = 0; index < flatArray.length; index++) {
      const element = flatArray[index];
      if (!(index % 2 === 0)) {
        result = result + element;
      }
    }
    return result
  }

  static sumWithNullArgArray(argArray) {
    let flatArray = argArray.flat()
    if (flatArray.length > 1) {
      flatArray.pop()
    }
    let result = flatArray.reduce((a, b) => {
      return a + b
    }, 0)
    return result
  }

  static sumObjectValuesOfTableSchema(object, lastPYear, actualYearsDuration) {
    const firstFYear = Number(lastPYear) + 1;
		let sum = 0;
    let index = 0;

    for (const key in object) {
			const keyInt = Number(key);
      if (keyInt >= firstFYear) {
        index++;
      }
      if (keyInt >= firstFYear && !isNaN(keyInt)) {
        sum += object[key].x
      }
      if (index == actualYearsDuration) {
        return sum;
      }
    }

		return sum
  }

  static getObjectValuesOfTableSchema(object, lastPYear) {
    const firstFYear = Number(lastPYear) + 1;
		const array = [];

    for (const key in object) {
			const keyInt = Number(key);
      if (keyInt >= firstFYear && !isNaN(keyInt)) {
        array.push(object[key].x)
      }
    }

    return array
  }

  static getLastPastYearValueOfTableSchema(object, lastPYear) {
    return object[lastPYear].x
  }

  static getFirstFutureYearValueOfTableSchema(object, lastPYear) {
    const firstFYear = +lastPYear + 1;
		return object[firstFYear].x
  }

  static minArg(argArray, yearsDur) {
    let flatArray = argArray.flat()
    if (yearsDur === undefined || yearsDur === null) {
      return Math.min(...flatArray)
    } else {
      const yearsDurArray = flatArray.slice(0, yearsDur);
      return Math.min(...yearsDurArray)
    }
  }

  static maxArg(argArray, yearsDur) {
    let flatArray = argArray.flat()
    if (yearsDur === undefined || yearsDur === null) {
      return Math.max(...flatArray)
    } else {
      const yearsDurArray = flatArray.slice(0, yearsDur);
      return Math.max(...yearsDurArray)
    }
  }

  static avg(argArray, yearsDur) {
    let flatArray = argArray.flat()

    if (yearsDur === undefined || yearsDur === null) {
      return flatArray.reduce((a, b) => a + b, 0) / flatArray.length;
    } else {
      const yearsDurArray = flatArray.slice(0, yearsDur);
      return yearsDurArray.reduce((a, b) => a + b, 0) / yearsDurArray.length;
    }
  }

  static minArgWithoutZeros(argArray) {
    let flatArray = argArray.flat()
    flatArray = flatArray.filter((argArray) => {
      return argArray != 0;
    })
    return Math.min(...flatArray)
  }

  static maxArgWithoutZeros(argArray) {
    let flatArray = argArray.flat()
    flatArray = flatArray.filter((argArray) => {
      return argArray != 0;
    })
    return Math.max(...flatArray)
  }

  static avgWithoutZeros(argArray) {
    let flatArray = argArray.flat()
    flatArray = flatArray.filter((argArray) => {
      return argArray != 0;
    })
    return flatArray.reduce((a, b) => a + b, 0) / flatArray.length;
  }

  static logTest(fYearCardinalNumber, yearsDur, preammYears, previousYearsSum, startYearCardinalNumber) {
    if (startYearCardinalNumber === undefined || startYearCardinalNumber === null) startYearCardinalNumber = 1;
    console.log("fYearCardinalNumber", fYearCardinalNumber);
    console.log("yearsDur", yearsDur);
    console.log("preammYears", preammYears);
    console.log("previousYearsSum", previousYearsSum);
    console.log("startYearCardinalNumber", startYearCardinalNumber);
    const startYearCardinalNumberMinusOne = startYearCardinalNumber - 1;
    let exp1 = (fYearCardinalNumber <= (yearsDur + preammYears + startYearCardinalNumberMinusOne)) ? 1 : 0;
    let exp2 = ((fYearCardinalNumber - preammYears + startYearCardinalNumberMinusOne) > 0) ? 1 : 0;
    let result = exp1 * exp2
    if(fYearCardinalNumber == 1) return result;
    let exp3 = (fYearCardinalNumber > (yearsDur + preammYears + startYearCardinalNumberMinusOne)) ? 1 : 0;
    let exp4 = (fYearCardinalNumber - preammYears + startYearCardinalNumberMinusOne > 0) ? 1 : 0;
    result = result + ((yearsDur - previousYearsSum) * exp3) * exp4
    return result;
  }

  static invisibleSixthAndSeventhTable(fYearCardinalNumber, yearsDur, preammYears, previousYearsSum, startYearCardinalNumber) {
    if (startYearCardinalNumber === undefined || startYearCardinalNumber === null) startYearCardinalNumber = 1;
    const startYearCardinalNumberMinusOne = startYearCardinalNumber - 1;
    let exp1 = (fYearCardinalNumber <= (yearsDur + preammYears + startYearCardinalNumberMinusOne)) ? 1 : 0;
    let exp2 = ((fYearCardinalNumber - preammYears + startYearCardinalNumberMinusOne) > 0) ? 1 : 0;
    let result = exp1 * exp2
    if(fYearCardinalNumber == 1) return result;
    let exp3 = (fYearCardinalNumber > (yearsDur + preammYears + startYearCardinalNumberMinusOne)) ? 1 : 0;
    let exp4 = (fYearCardinalNumber - preammYears + startYearCardinalNumberMinusOne > 0) ? 1 : 0;
    result = result + ((yearsDur - previousYearsSum) * exp3) * exp4
    return result;
  }

  static size(argArray) {
    let flatArray = argArray.flat()
    return flatArray.length;
  }

  static searchLeasingYear(argArray) {
    let flatArray = argArray.flat();
    let indexes = [];
    for (let index = 0; index < flatArray.length; index++) {
      const element = flatArray[index];
      if(element != 0) {
        indexes.push(index + 1)
      }
    }
    if (indexes.length > 0) {
      return Math.max(...indexes);
    } else {
      return 0
    }
  }

  static produceGrossRateKeyString(string) {
    return "Tasso lordo " + string;
  }

  static yearFrac(date1, date2, flag) {
    if (!date1 || !date2) {
      return NaN;
    }
    if (flag == 0) return DateUtilities.getRangeYearFraction30_360(date1, date2);
    if (flag == 1) return DateUtilities.getRangeYearFractionActual(date1, date2);
    else return NaN;
  }

  static roundDown(num, decimal) {
    const factor = Math.pow(10, decimal);
    return Math.floor(num * factor) / factor;
  }

  static dateStartYear(year) {
    const isInteger = parseInt(year) == year;
    if (isInteger) {
      return year + '-01-01';
    }
    const date = new Date(year);
    return date.getFullYear() + '-01-01';
  }

  static dateEndYear(year) {
    const isInteger = parseInt(year) == year;
    if (isInteger) {
      return year + '-12-31';
    }
    const date = new Date(year);
    return date.getFullYear() + '-12-31';
  }

  static dateDiff(date1, date2) {
    if (!date1) return NaN;
    if (!date2) return NaN;
    let d1 = new Date(date1);
    let d2 = new Date(date2);
    let diff = (d1.getTime() - d2.getTime()) / (1000 * 60 * 60 * 24); // ms in a day
    return diff;
  }

  static dateEq(date1, date2) {
    let d1 = new Date(date1);
    let d2 = new Date(date2);
    return this.eq(d1, d2);
  }

  static dateG(date1, date2) {
    let d1 = new Date(date1);
    let d2 = new Date(date2);
    return this.g(d1, d2);
  }

  static dateGe(date1, date2) {
    let d1 = new Date(date1);
    let d2 = new Date(date2);
    return this.ge(d1, d2);
  }

  static dateMax(date1, date2) {
    let d1 = new Date(date1);
    let d2 = new Date(date2);
    return this.max(d1, d2);
  }

  static dateMin(date1, date2) {
    let d1 = new Date(date1);
    let d2 = new Date(date2);
    return this.min(d1, d2);
  }

  static format(date) {
    const d = new Date(date);
    const year  = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day   = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  static dateAddDays(date, days) {
    if (!date) return null;
    if (!Number.isFinite(days)) return null;
    let d = new Date(date);
    let result = new Date(d.getTime() + days * (1000 * 60 * 60 * 24));
    return result;
  }

  static getReferenceDateBP() {
    let bp = Store.getters["businessPlan/getBusinessPlan"];
    let referenceDate = bp ? bp.referenceDate : null;
  
    if (!referenceDate) {
      let sharedData = Store.getters["shared/getSharedData"];
      bp = sharedData ? sharedData.businessPlanObject : null;
      referenceDate = bp ? bp.referenceDate : null;
    }

    if (!referenceDate) {
      return new Date(NaN); // Invalid Date
    }
    
    let date = new Date(referenceDate);
    var fDate = this.format(date);
    return fDate;
  }
  
  static int(number) {
    if (!number) return NaN;
    return parseInt(number);
  }

  static cumipmt(rate, periods, value, start, end, type) {

    // console.log('cumpipmt: ', rate, periods, value, start, end, type);
  
    // check if any inputs are errors.
    if (!rate || !periods || !value) {
      return NaN;
    }
  
    // Return error if either rate, periods, or value are lower than or equal to zero
    if (rate <= 0 || periods <= 0 || value <= 0) {
      return NaN;
    }
  
    // Return error if start < 1, end < 1, or start > end
    if (start < 1 || end < 1 || start > end) {
      return NaN;
    }
  
    // Return error if type is neither 0 nor 1
    if (type !== 0 && type !== 1) {
      return NaN;
    }
  
    // Compute cumulative interest
    var payment = this.pmt(rate, periods, value, 0, type);
    var interest = 0;
  
    if (start === 1) {
      if (type === 0) {
        interest = -value;
        start++;
      }
    }
  
    for (var i = start; i <= end; i++) {
      if (type === 1) {
        interest += this.fv(rate, i - 2, payment, value, 1) - payment;
      } else {
        interest += this.fv(rate, i - 1, payment, value, 0);
      }
    }
    interest *= rate;
  
    // Return cumulative interest
    return interest;
  }

  static cumprinc(rate, periods, value, start, end, type) {

    //console.log('cumprinc: ', rate, periods, value, start, end, type);

    // Return error if either rate, periods, or value are lower than or equal to zero
    if (rate <= 0 || periods <= 0 || value <= 0) {
      return NaN;
    }
  
    // Return error if start < 1, end < 1, or start > end
    if (start < 1 || end < 1 || start > end) {
      return NaN;
    }
  
    // Return error if type is neither 0 nor 1
    if (type !== 0 && type !== 1) {
      return NaN;
    }
  
    // Compute cumulative principal
    var payment = this.pmt(rate, periods, value, 0, type);
    var principal = 0;
    if (start === 1) {
      if (type === 0) {
        principal = payment + value * rate;
      } else {
        principal = payment;
      }
      start++;
    }
    for (var i = start; i <= end; i++) {
      if (type > 0) {
        principal += payment - (this.fv(rate, i - 2, payment, value, 1) - payment) * rate;
      } else {
        principal += payment - this.fv(rate, i - 1, payment, value, 0) * rate;
      }
    }
  
    // Return cumulative principal
    return principal;
  };

  static fv(rate, periods, payment, value, type) {
    // Credits: algorithm inspired by Apache OpenOffice
  
    value = value || 0;
    type = type || 0;
  
    // Return future value
    var result;
    if (rate === 0) {
      result = value + payment * periods;
    } else {
      var term = Math.pow(1 + rate, periods);
      if (type === 1) {
        result = value * term + payment * (1 + rate) * (term - 1) / rate;
      } else {
        result = value * term + payment * (term - 1) / rate;
      }
    }
    return -result;
  };

  static pmt(rate, nper, pv, fv, type) {
    if (!fv) fv = 0;
    if (!type) type = 0;

    if (rate == 0) return -(pv + fv) / nper;

    var pvif = Math.pow(1 + rate, nper);
    var pmt = rate / (pvif - 1) * -(pv * pvif + fv);

    if (type == 1) {
      pmt /= (1 + rate);
    };

    return pmt;
  }

  static ipmtWithNaNReturn(rate, per, nper, pv, fv, type) {

    if (per == 0) {
      return NaN;
    }

    if (per >= nper + 1) {
      return NaN;
    }

    let res = Ast.ipmt(rate, per, nper, pv, fv, type);
    return res;
  }

  static ipmt(rate, per, nper, pv, fv, type) {
    let perMinusOne = per - 1;

    if (per == 0) {
      return 0;
    }

    if (per >= nper + 1) {
      return 0;
    }

    let pmt = this.pmt(rate, nper, pv, fv, type);
    var tmp = Math.pow(1 + rate, perMinusOne);
    let result = 0 - (pv * tmp * rate + pmt * (tmp - 1));

    //? Commentato per far tornare i risultati del leasing nella tabella invisibile 1 se vengono inseriti maxi canone, tasso e riscatto, ma non una cifra di leasing
    /* if (result > 0) {
      return 0;
    } */

    return result;
  }

  static ppmt(rate, per, nper, pv, fv, type) {
    if (per < 1 || (per >= nper + 1)) return 0; //NaN
    var pmt = this.pmt(rate, nper, pv, fv, type);
    var ipmt = this.ipmt(rate, per, nper, pv, fv, type);
    return (pmt - ipmt);
  }

  static async automaticCellsCompilation(easyModeTemplate) {
    let workbook = Store.getters["workbook/getWorkbook"];

    easyModeTemplate.defaultValues.forEach((defValue) => {
      let defValueTable = workbook.tableMap.get(defValue.table);

      if(workbook.data[defValue.c]) {
        workbook.data[defValue.c].forEach((colKey) => {
          defValueTable.sheet[defValueTable.rows.key2idx.get(defValue.r)][colKey].x;

          let ri = defValueTable.rows.key2idx.get(defValue.r);
          let ck = colKey.toString();
          let ci = defValueTable.cols.key2idx.get(ck);

          Grid.setValue(Store.getters["workbook/getWorkbook"], defValueTable, ri, ck, Grid.evaluateFormula(defValue, workbook, ci, ri));
          Grid.updateRelatedCells(Store.getters["workbook/getWorkbook"], defValueTable, Store.getters["workbook/getWorkbook"].data, ri, ck);
        })
      } else if(workbook.properties[defValue.c]) {
        workbook.properties[defValue.c].forEach((colKey) => {
          defValueTable.sheet[defValueTable.rows.key2idx.get(defValue.r)][colKey].x;

          let ri = defValueTable.rows.key2idx.get(defValue.r);
          let ck = colKey.toString();
          let ci = defValueTable.cols.key2idx.get(ck);

          Grid.setValue(Store.getters["workbook/getWorkbook"], defValueTable, ri, ck, Grid.evaluateFormula(defValue, workbook, ci, ri));
          Grid.updateRelatedCells(Store.getters["workbook/getWorkbook"], defValueTable, Store.getters["workbook/getWorkbook"].data, ri, ck);
        })
      }
    });

    Grid.updateRowData(Store.getters["workbook/getWorkbook"]);
  }

  static dsrcSolver(dsrcAvgTarget, lastPYear) {
    let ri = 14;
    let ck = lastPYear
    let additionalDebt;

    const actualYearsDurationObject = { ...Store.getters["workbook/getSelectedTable"].sheet[15] };
    const actualYearsDuration = this.getLastPastYearValueOfTableSchema(actualYearsDurationObject, lastPYear);

    // Per gestire il caso in cui il debito aggiuntivo sia 0
    const actualAdditionalDebtObject = { ...Store.getters["workbook/getSelectedTable"].sheet[14] };
    const actualAdditionalDebt = this.getLastPastYearValueOfTableSchema(actualAdditionalDebtObject, lastPYear);
    let actualAdditionalDebtValue = actualAdditionalDebt;
    if ( !actualAdditionalDebt || isNaN(actualAdditionalDebt) || actualAdditionalDebt <= 0 ) {
      Grid.setValue(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], ri, ck, 1);
      Grid.updateRelatedCells(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], Store.getters["workbook/getWorkbook"].data, ri, ck);
      actualAdditionalDebtValue = 1;
    }

    let dsrcAvgActualObject = { ...Store.getters["workbook/getSelectedTable"].sheet[10] }
    let dsrcAvgActual = this.getLastPastYearValueOfTableSchema(dsrcAvgActualObject, lastPYear)

    let availableCashSumObject = { ...Store.getters["workbook/getSelectedTable"].sheet[3] }
    let availableCashSum = this.sumObjectValuesOfTableSchema(availableCashSumObject, lastPYear, actualYearsDuration)

    if ((availableCashSum == 0 && dsrcAvgTarget != 0) || (dsrcAvgTarget == 0 && dsrcAvgActual != 0)) {
      additionalDebt = NaN;
      showErrorSnackbar(500, i18n.t("error-dscr-solver"));
      return actualAdditionalDebt;
    } else {
      additionalDebt = dsrcAvgActual / dsrcAvgTarget * actualAdditionalDebtValue;
    }

    Grid.setValue(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], ri, ck, additionalDebt);
    Grid.updateRelatedCells(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], Store.getters["workbook/getWorkbook"].data, ri, ck);

    /* 
    // Versione con solver
    let param;
    if (Math.abs(dsrcAvgTarget - dsrcAvgActual) >= 10000000) {
      param = 1 / 1000000
    } else if (Math.abs(dsrcAvgTarget - dsrcAvgActual) >= 1000000) {
      param = 1 / 100000
    } else if (Math.abs(dsrcAvgTarget - dsrcAvgActual) >= 100000) {
      param = 1 / 10000
    } else if (Math.abs(dsrcAvgTarget - dsrcAvgActual) >= 10000) {
      param = 1 / 1000
    } else if (Math.abs(dsrcAvgTarget - dsrcAvgActual) >= 1000) {
      param = 1 / 100
    } else if (Math.abs(dsrcAvgTarget - dsrcAvgActual) >= 100) {
      param = 1 / 10
    } else if (Math.abs(dsrcAvgTarget - dsrcAvgActual) >= 1) {
      param = 100
    } else if (Math.abs(dsrcAvgTarget - dsrcAvgActual) >= 0.1) {
      param = 1000
    } else if (Math.abs(dsrcAvgTarget - dsrcAvgActual) >= 0.01) {
      param = 10000
    } else {
      param = 100000
    }

    let dynamicIndex = Math.abs(parseInt((dsrcAvgTarget - dsrcAvgActual) * param)) >= 1 ? Math.abs(parseInt((dsrcAvgTarget - dsrcAvgActual) * param)) : 1;

    for (let i = 0; i < dynamicIndex; i++) {
      let availableCashSumObject = { ...Store.getters["workbook/getSelectedTable"].sheet[3] }
      let availableCashSum = this.sumObjectValuesOfTableSchema(availableCashSumObject, lastPYear)

      let principalInstallmentSumObject = { ...Store.getters["workbook/getSelectedTable"].sheet[4] }
      let principalInstallmentSum = this.sumObjectValuesOfTableSchema(principalInstallmentSumObject, lastPYear)

      let taxInterestRateSumObject = { ...Store.getters["workbook/getSelectedTable"].sheet[7] }
      let taxInterestRateSum = this.sumObjectValuesOfTableSchema(taxInterestRateSumObject, lastPYear)

      let dsrcAvgActualObject = { ...Store.getters["workbook/getSelectedTable"].sheet[10] }
      let dsrcAvgActual = this.getLastPastYearValueOfTableSchema(dsrcAvgActualObject, lastPYear)

      let additionalDebtObject = { ...Store.getters["workbook/getSelectedTable"].sheet[14] }
      additionalDebt = this.getLastPastYearValueOfTableSchema(additionalDebtObject, lastPYear)
      let oldAdditionalDebt = additionalDebt

      // additionalDebt = (additionalDebt - Math.pow((principalInstallmentSum + taxInterestRateSum), 2) * ((dsrcAvgActual + (dsrcAvgTarget - dsrcAvgActual) * ((i + 1) / dynamicIndex)) - dsrcAvgActual) / availableCashSum);
      additionalDebt = (additionalDebt - Math.pow((principalInstallmentSum + taxInterestRateSum), 2) * ((dsrcAvgTarget - dsrcAvgActual) * ((i + 1) / dynamicIndex)) / availableCashSum);

      Grid.setValue(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], ri, ck, additionalDebt);
      Grid.updateRelatedCells(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], Store.getters["workbook/getWorkbook"].data, ri, ck);

      if (oldAdditionalDebt.toFixed(4) === additionalDebt.toFixed(4)) {
        break
      }
    } */

    Grid.updateRowData(Store.getters["workbook/getWorkbook"]);

    return additionalDebt;
  }

  static dsrcMinSolver(dsrcMinTarget, lastPYear) {
    let ri = 14;
    let ck = lastPYear
    let additionalDebt;

    const actualYearsDurationObject = { ...Store.getters["workbook/getSelectedTable"].sheet[15] };
    const actualYearsDuration = this.getLastPastYearValueOfTableSchema(actualYearsDurationObject, lastPYear);

    // Per gestire il caso in cui il debito aggiuntivo sia 0
    const actualAdditionalDebtObject = { ...Store.getters["workbook/getSelectedTable"].sheet[14] };
    const actualAdditionalDebt = this.getLastPastYearValueOfTableSchema(actualAdditionalDebtObject, lastPYear);
    let actualAdditionalDebtValue = actualAdditionalDebt;
    if ( !actualAdditionalDebt || isNaN(actualAdditionalDebt) || actualAdditionalDebt <= 0 ) {
      Grid.setValue(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], ri, ck, 1);
      Grid.updateRelatedCells(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], Store.getters["workbook/getWorkbook"].data, ri, ck);
      actualAdditionalDebtValue = 1;
    }

    let dsrcMinActualObject = { ...Store.getters["workbook/getSelectedTable"].sheet[11] }
    let dsrcMinActual = this.getLastPastYearValueOfTableSchema(dsrcMinActualObject, lastPYear)
    let dsrcMaxActualObject = { ...Store.getters["workbook/getSelectedTable"].sheet[12] }
    let dsrcMaxActual = this.getLastPastYearValueOfTableSchema(dsrcMaxActualObject, lastPYear)

    let dsrcArrayObject = { ...Store.getters["workbook/getSelectedTable"].sheet[9] };
    let dsrcArray = this.getObjectValuesOfTableSchema(dsrcArrayObject, lastPYear);
    let minDsrc = this.minArg(dsrcArray, actualYearsDuration);
    let minDsrcIndex = dsrcArray.indexOf(minDsrc);
    let maxDsrc = this.maxArg(dsrcArray, actualYearsDuration);
    let maxDsrcIndex = dsrcArray.indexOf(maxDsrc);

    let availableCashArrayObject = { ...Store.getters["workbook/getSelectedTable"].sheet[3] }
    let availableCashArray = this.getObjectValuesOfTableSchema(availableCashArrayObject, lastPYear)
    let minDsrcYearAvailableCashActual = availableCashArray[minDsrcIndex]
    let maxDsrcYearAvailableCashActual = availableCashArray[maxDsrcIndex]
    
    if ((dsrcMinActual >= 0 && dsrcMinTarget >= 0) || (dsrcMinActual < 0 && dsrcMinTarget < 0)) {
      if ((minDsrcYearAvailableCashActual == 0 && dsrcMinTarget != 0) || (dsrcMinTarget == 0 && dsrcMinActual != 0)) {
        additionalDebt = NaN;
        showErrorSnackbar(500, i18n.t("error-dscr-solver"));
        return actualAdditionalDebt;
      } else {
        additionalDebt = dsrcMinActual / dsrcMinTarget * actualAdditionalDebtValue;
      }
    } else {
      if((dsrcMinActual >= 0 && dsrcMaxActual >= 0) || (dsrcMinActual < 0 && dsrcMaxActual < 0)) {
        if ((maxDsrcYearAvailableCashActual == 0 && dsrcMinTarget != 0) || (dsrcMinTarget == 0 && dsrcMaxActual != 0)) {
          additionalDebt = NaN;
          showErrorSnackbar(500, i18n.t("error-dscr-solver"));
          return actualAdditionalDebt;
        } else {
          additionalDebt = dsrcMaxActual / dsrcMinTarget * actualAdditionalDebtValue;
        }
      } else {
        additionalDebt = NaN;
        showErrorSnackbar(500, i18n.t("error-dscr-solver"));
        return actualAdditionalDebt;
      }
    }

    Grid.setValue(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], ri, ck, additionalDebt);
    Grid.updateRelatedCells(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], Store.getters["workbook/getWorkbook"].data, ri, ck);

    /* 
    // Versione con solver
    let param;
    if (Math.abs(dsrcMinTarget - dsrcMinActual) >= 10000000) {
      param = 1 / 10000
    } else if (Math.abs(dsrcMinTarget - dsrcMinActual) >= 1000000) {
      param = 1 / 1000
    } else if (Math.abs(dsrcMinTarget - dsrcMinActual) >= 100000) {
      param = 1 / 100
    } else if (Math.abs(dsrcMinTarget - dsrcMinActual) >= 10000) {
      param = 1 / 10
    } else if (Math.abs(dsrcMinTarget - dsrcMinActual) >= 10) {
      param = 100
    } else if (Math.abs(dsrcMinTarget - dsrcMinActual) >= 1) {
      param = 100 * 4
    }  else if (Math.abs(dsrcMinTarget - dsrcMinActual) >= 0.1) {
      param = 1000 * 2
    } else if (Math.abs(dsrcMinTarget - dsrcMinActual) >= 0.01) {
      param = 10000
    } else {
      param = 100000
    }

    let dynamicIndex = Math.abs(parseInt((dsrcMinTarget - dsrcMinActual) * param)) >= 1 ? Math.abs(parseInt((dsrcMinTarget - dsrcMinActual) * param * 1.2)) : 1;

    for (let i = 0; i < dynamicIndex; i++) {
      let dscrArrayObject = { ...Store.getters["workbook/getSelectedTable"].sheet[9] };
      let dscrArray = this.getObjectValuesOfTableSchema(dscrArrayObject, lastPYear);
      let minDscr = this.minArg(dscrArray);
      let minDscrIndex = dscrArray.indexOf(minDscr);

      let availableCashArrayObject = { ...Store.getters["workbook/getSelectedTable"].sheet[3] }
      let availableCashArray = this.getObjectValuesOfTableSchema(availableCashArrayObject, lastPYear)
      let availableCashActual = availableCashArray[minDscrIndex] // (I7)

      let principalInstallmentArrayObject = { ...Store.getters["workbook/getSelectedTable"].sheet[4] }
      let principalInstallmentArray = this.getObjectValuesOfTableSchema(principalInstallmentArrayObject, lastPYear)
      let principalInstallmentActual = principalInstallmentArray[minDscrIndex] // (I9)

      let taxInterestRateArrayObject = { ...Store.getters["workbook/getSelectedTable"].sheet[7] }
      let taxInterestRateArray = this.getObjectValuesOfTableSchema(taxInterestRateArrayObject, lastPYear)
      let taxInterestRateActual = taxInterestRateArray[minDscrIndex] // (I12)

      let dsrcMinActualObject = { ...Store.getters["workbook/getSelectedTable"].sheet[11] }
      let dsrcMinActual = this.getLastPastYearValueOfTableSchema(dsrcMinActualObject, lastPYear)

      let additionalDebtObject = { ...Store.getters["workbook/getSelectedTable"].sheet[14] }
      additionalDebt = this.getLastPastYearValueOfTableSchema(additionalDebtObject, lastPYear)

      let oldAdditionalDebt = additionalDebt;

      // additionalDebt = (additionalDebt - Math.pow((principalInstallmentActual + taxInterestRateActual), 2) * ((dsrcMinActual + (dsrcMinTarget - dsrcMinActual) * ((i + 1) / dynamicIndex)) - dsrcMinActual) / availableCashActual);
      additionalDebt = (additionalDebt - Math.pow((principalInstallmentActual + taxInterestRateActual), 2) * ((dsrcMinTarget - dsrcMinActual) * ((i + 1) / dynamicIndex)) / availableCashActual);

      Grid.setValue(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], ri, ck, additionalDebt);
      Grid.updateRelatedCells(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], Store.getters["workbook/getWorkbook"].data, ri, ck);

      if (oldAdditionalDebt.toFixed(4) === additionalDebt.toFixed(4)) {
        break
      }
    } */

    Grid.updateRowData(Store.getters["workbook/getWorkbook"]);

    return additionalDebt;
  }

  static dsrcMaxSolver(dsrcMaxTarget, lastPYear) {
    let ri = 14;
    let ck = lastPYear
    let additionalDebt;

    const actualYearsDurationObject = { ...Store.getters["workbook/getSelectedTable"].sheet[15] };
    const actualYearsDuration = this.getLastPastYearValueOfTableSchema(actualYearsDurationObject, lastPYear);

    // Per gestire il caso in cui il debito aggiuntivo sia 0
    const actualAdditionalDebtObject = { ...Store.getters["workbook/getSelectedTable"].sheet[14] };
    const actualAdditionalDebt = this.getLastPastYearValueOfTableSchema(actualAdditionalDebtObject, lastPYear);
    let actualAdditionalDebtValue = actualAdditionalDebt;
    if ( !actualAdditionalDebt || isNaN(actualAdditionalDebt) || actualAdditionalDebt <= 0 ) {
      Grid.setValue(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], ri, ck, 1);
      Grid.updateRelatedCells(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], Store.getters["workbook/getWorkbook"].data, ri, ck);
      actualAdditionalDebtValue = 1;
    }
    
    let dsrcMaxActualObject = { ...Store.getters["workbook/getSelectedTable"].sheet[12] }
    let dsrcMaxActual = this.getLastPastYearValueOfTableSchema(dsrcMaxActualObject, lastPYear)
    let dsrcMinActualObject = { ...Store.getters["workbook/getSelectedTable"].sheet[11] }
    let dsrcMinActual = this.getLastPastYearValueOfTableSchema(dsrcMinActualObject, lastPYear)

    let dsrcArrayObject = { ...Store.getters["workbook/getSelectedTable"].sheet[9] };
    let dsrcArray = this.getObjectValuesOfTableSchema(dsrcArrayObject, lastPYear);
    let maxDsrc = this.maxArg(dsrcArray, actualYearsDuration);
    let maxDsrcIndex = dsrcArray.indexOf(maxDsrc);
    let minDsrc = this.minArg(dsrcArray, actualYearsDuration);
    let minDsrcIndex = dsrcArray.indexOf(minDsrc);

    let availableCashArrayObject = { ...Store.getters["workbook/getSelectedTable"].sheet[3] }
    let availableCashArray = this.getObjectValuesOfTableSchema(availableCashArrayObject, lastPYear)
    let maxDsrcYearAvailableCashActual = availableCashArray[maxDsrcIndex]
    let minDsrcYearAvailableCashActual = availableCashArray[minDsrcIndex]
    
    if ((dsrcMaxActual >= 0 && dsrcMaxTarget >= 0) || (dsrcMaxActual < 0 && dsrcMaxTarget < 0)) {
      if ((maxDsrcYearAvailableCashActual == 0 && dsrcMaxTarget != 0) || (dsrcMaxTarget == 0 && dsrcMaxActual != 0)) {
        additionalDebt = NaN;
        showErrorSnackbar(500, i18n.t("error-dscr-solver"));
        return actualAdditionalDebt;
      } else {
        additionalDebt = dsrcMaxActual / dsrcMaxTarget * actualAdditionalDebtValue;
      }
    } else {
      if((dsrcMaxActual >= 0 && dsrcMinActual >= 0) || (dsrcMaxActual < 0 && dsrcMinActual < 0)) {
        if ((minDsrcYearAvailableCashActual == 0 && dsrcMaxTarget != 0) || (dsrcMaxTarget == 0 && dsrcMinActual != 0)) {
          additionalDebt = NaN;
          showErrorSnackbar(500, i18n.t("error-dscr-solver"));
          return actualAdditionalDebt;
        } else {
          additionalDebt = dsrcMinActual / dsrcMaxTarget * actualAdditionalDebtValue;
        }
      } else {
        additionalDebt = NaN;
        showErrorSnackbar(500, i18n.t("error-dscr-solver"));
        return actualAdditionalDebt;
      }
    }

    Grid.setValue(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], ri, ck, additionalDebt);
    Grid.updateRelatedCells(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], Store.getters["workbook/getWorkbook"].data, ri, ck);

    /* 
    // Versione con solver
    let param;

    if (Math.abs(dsrcMaxTarget - dsrcMaxActual) >= 1000000) {
      param = 1 / 1000
    } else if (Math.abs(dsrcMaxTarget - dsrcMaxActual) >= 100000) {
      param = 1 / 100
    } else if (Math.abs(dsrcMaxTarget - dsrcMaxActual) >= 10000) {
      param = 1 / 10
    } else if (Math.abs(dsrcMaxTarget - dsrcMaxActual) >= 1000) {
      param = 3
    } else if (Math.abs(dsrcMaxTarget - dsrcMaxActual) >= 10) {
      param = 100
    } else if (Math.abs(dsrcMaxTarget - dsrcMaxActual) >= 1) {
      param = 100 * 4
    }  else if (Math.abs(dsrcMaxTarget - dsrcMaxActual) >= 0.1) {
      param = 1000 * 2
    } else if (Math.abs(dsrcMaxTarget - dsrcMaxActual) >= 0.01) {
      param = 10000
    } else {
      param = 100000
    }

    let dynamicIndex = Math.abs(parseInt((dsrcMaxTarget - dsrcMaxActual) * param)) >= 1 ? Math.abs(parseInt((dsrcMaxTarget - dsrcMaxActual) * param)) : 1;

    for (let i = 0; i < dynamicIndex; i++) {
      let dscrArrayObject = { ...Store.getters["workbook/getSelectedTable"].sheet[9] };
      let dscrArray = this.getObjectValuesOfTableSchema(dscrArrayObject, lastPYear);
      let maxDscr = this.maxArg(dscrArray);
      let maxDscrIndex = dscrArray.indexOf(maxDscr);

      let availableCashArrayObject = { ...Store.getters["workbook/getSelectedTable"].sheet[3] }
      let availableCashArray = this.getObjectValuesOfTableSchema(availableCashArrayObject, lastPYear)
      let availableCashActual = availableCashArray[maxDscrIndex]

      let principalInstallmentArrayObject = { ...Store.getters["workbook/getSelectedTable"].sheet[4] }
      let principalInstallmentArray = this.getObjectValuesOfTableSchema(principalInstallmentArrayObject, lastPYear)
      let principalInstallmentActual = principalInstallmentArray[maxDscrIndex]

      let taxInterestRateArrayObject = { ...Store.getters["workbook/getSelectedTable"].sheet[7] }
      let taxInterestRateArray = this.getObjectValuesOfTableSchema(taxInterestRateArrayObject, lastPYear)
      let taxInterestRateActual = taxInterestRateArray[maxDscrIndex]

      let dsrcMaxActualObject = { ...Store.getters["workbook/getSelectedTable"].sheet[12] }
      let dsrcMaxActual = this.getLastPastYearValueOfTableSchema(dsrcMaxActualObject, lastPYear)

      let additionalDebtObject = { ...Store.getters["workbook/getSelectedTable"].sheet[14] }
      additionalDebt = this.getLastPastYearValueOfTableSchema(additionalDebtObject, lastPYear)

      let oldAdditionalDebt = additionalDebt;

      // additionalDebt = (additionalDebt - Math.pow((principalInstallmentActual + taxInterestRateActual), 2) * ((dsrcMaxActual + (dsrcMaxTarget - dsrcMaxActual) * ((i + 1) / dynamicIndex)) - dsrcMaxActual) / availableCashActual);
      additionalDebt = (additionalDebt - Math.pow((principalInstallmentActual + taxInterestRateActual), 2) * ((dsrcMaxTarget - dsrcMaxActual) * ((i + 1) / dynamicIndex)) / availableCashActual);

      Grid.setValue(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], ri, ck, additionalDebt);
      Grid.updateRelatedCells(Store.getters["workbook/getWorkbook"], Store.getters["workbook/getSelectedTable"], Store.getters["workbook/getWorkbook"].data, ri, ck);

      if (oldAdditionalDebt.toFixed(4) === additionalDebt.toFixed(4)) {
        break
      }
    } */

    Grid.updateRowData(Store.getters["workbook/getWorkbook"]);

    return additionalDebt;
  }

  static additionalDebtCapacityTabButton(selectFieldInput, textFieldInput) {
    const workbook = Store.getters["workbook/getWorkbook"];
    const lastPYear = workbook.data.lastPYear[0];

    if (selectFieldInput == 0) {
      this.dsrcSolver(textFieldInput, lastPYear)
    } else if (selectFieldInput == 1) {
      this.dsrcMinSolver(textFieldInput, lastPYear)
    } else if (selectFieldInput == 2) {
      this.dsrcMaxSolver(textFieldInput, lastPYear)
    }
  }

  static checkStore(number) {
    return parseInt(number)
  }

  static unpackRange(range) {
    if (Ast.isNumber(range)) {
      return [range]
    }
    if (Ast.isArray(range)) {
      let refs = []
      for (let i = range[0]; i < range[1]; i++) refs.push(i)
      return refs
    }
    throw {
      msg: "expected number or range",
      obj: range
    }
  }

  static evaluate(schema, data, ast, value) {
    if (Ast.isObject(ast)) {
      if (ast.op == '+') return Ast.evaluate(schema, data, ast["1"], value) + Ast.evaluate(schema, data, ast["2"], value)
      if (ast.op == '-') return Ast.evaluate(schema, data, ast["1"], value) - Ast.evaluate(schema, data, ast["2"], value)
      if (ast.op == '*') return Ast.evaluate(schema, data, ast["1"], value) * Ast.evaluate(schema, data, ast["2"], value)
      if (ast.op == '/') return Ast.evaluate(schema, data, ast["1"], value) / Ast.evaluate(schema, data, ast["2"], value)
      if (ast.op == 'o') {
        if (data[ast.identifier] == undefined) return 0.0
        let obj = data[ast.identifier]
        for (let key of ast.args) {
          if (obj[key] == undefined) return 0.0
          obj = obj[key]
        }
        return obj
      }
      if (ast.op == 'c') {
        let table = schema.tableMap.get(ast.table)
        let isRange = Ast.isArray(ast.r) || Ast.isArray(ast.c)
        if (isRange) {
          let rows = Ast.unpackRange(ast.r)
          let cols = Ast.unpackRange(ast.c)
          let x = []
          for (let r of rows) {
            for (let c of cols) {
              let ck = table.cols.keys[c]
              let row = table.sheet[r]
              if (ck == undefined || row == undefined) x.push(0.0)
              else x.push(row[ck].x)
            }
          }
          return x
        }
        else {
          let ck = table.cols.keys[ast.c]
          let row = table.sheet[ast.r]
          if (ck == undefined) return 0.0
          if (row == undefined) return 0.0
          let cell = row[ck]
          return cell.x
        }
      }
      if (Ast.isFunction(ast)) {
        let arg_vals = ast.args.map(e => Ast.evaluate(schema, data, e, value))
        return Ast.fn(ast.op, arg_vals)
      }
    }
    else if (Ast.isArray(ast)) {
      return ast.map(x => Ast.evaluate(schema, data, x, value))
    }
    else if (Ast.isNumber(ast)) return ast
    else if (Ast.isString(ast)) {
      if (ast == '&v') return value
      else if (ast == '&n') return NaN
      else {
        return ast
      }
    }
    return undefined
  }

  static getPrecedents(ast) {
    let list = []
    Ast.getPrecedentsImp(list, ast)
    return list
  }

  static getPrecedentsImp(list, ast) {
    if (Ast.isObject(ast)) {
      if (ast.op == 'c') {
        let rows = Ast.unpackRange(ast.r)
        let cols = Ast.unpackRange(ast.c)
        for (let r of rows) {
          for (let c of cols) {
            list.push({
              table: ast.table,
              r: r,
              c: c
            })
          }

        }
      }
      else if (ast.op == '+' || ast.op == '-' || ast.op == '*' || ast.op == '/') {
        Ast.getPrecedentsImp(list, ast["1"])
        Ast.getPrecedentsImp(list, ast["2"])
      }
      else if (Ast.isFunction(ast)) {
        for (let arg of ast.args) Ast.getPrecedentsImp(list, arg)
      }
    }
  }

  static getProperty(workbook, id) {
    let obj = workbook.data[id]
    if (obj == undefined) obj = workbook.properties[id]
    return obj
  }

  static translateString(workbook, t, ast, ri, ci, axis) {
    if (ast == "$r") return ri
    if (ast == "$c") return ci
    let rj = t.rows.ids[ri].index
    let cj = t.cols.ids[ci].index
    if (ast == "@r") return rj
    if (ast == "@c") return cj
    let rk = t.rows.keys[ri]
    let ck = t.cols.keys[ci]
    if (ast == "#r") return rk
    if (ast == "#c") return ck
    if (ast[0] == '%') {
      if (!axis) {
        let currentTable = workbook.tableMap.get(t.name);
        axis = currentTable.rows;
        if (axis.key2idx.get(ast.substring(1))) {
          return axis.key2idx.get(ast.substring(1))
        } else {
          axis = currentTable.cols;
          return axis.key2idx.get(ast.substring(1))
        }
      } else {
        return axis.key2idx.get(ast.substring(1))
      }
    }
    if (ast[0] == "^") {
      let obj = Ast.getProperty(workbook, ast.substring(1))
      if (!Ast.isArray(obj)) throw {
        msg: "expected array",
        obj: ast
      }
      return obj.length
    }
    // In case of emergency we can implement something with this code
    /* if (ast[0] == "§") {
      let obj = Ast.getProperty(workbook, ast.substring(1))
      if (!Ast.isArray(obj)) throw {
        msg: "expected array",
        obj: ast
      }
      return obj
    } */
    return ast
  }

  static calculateRefs(arg) {
    if (Ast.isNumber(arg)) return arg
    else if (Ast.isString(arg)) return arg
    else if (Ast.isObject(arg)) {
      if (arg.op == '+') return Ast.calculateRefs(arg["1"]) + Ast.calculateRefs(arg["2"])
      if (arg.op == '-') return Ast.calculateRefs(arg["1"]) - Ast.calculateRefs(arg["2"])
      if (arg.op == '*') return Ast.calculateRefs(arg["1"]) * Ast.calculateRefs(arg["2"])
      if (arg.op == '/') return Ast.calculateRefs(arg["1"]) / Ast.calculateRefs(arg["2"])
    }
    else if (Ast.isArray(arg)) {
      return arg.map(x => Ast.calculateRefs(x))
    }
    throw {
      msg: "semantic error",
      obj: arg
    }
  }

  static translateAll(workbook, ast, t, ri, ci, axis) {
    if (Ast.isObject(ast)) {
      if (ast.op == '+' || ast.op == '-' || ast.op == '*' || ast.op == '/') {
        ast["1"] = Ast.translateAll(workbook, ast["1"], t, ri, ci)
        ast["2"] = Ast.translateAll(workbook, ast["2"], t, ri, ci)
      }
      if (Ast.isFunction(ast)) {
        for (let i in ast.args) ast.args[i] = Ast.translateAll(workbook, ast.args[i], t, ri, ci)
      }
      if (ast.op == 'o' && ast.args) {
        for (let i = 0; i < ast.args.length; i++) {
          ast.args[i] = Ast.translateAll(workbook, ast.args[i], t, ri, ci)
          ast.args[i] = Ast.calculateRefs(ast.args[i])
        }
      }
      if (ast.op == 'c') {
        let table = workbook.tableMap.get(ast.table)
        ast.r = Ast.translateAll(workbook, ast.r, t, ri, ci, table.rows)
        ast.c = Ast.translateAll(workbook, ast.c, t, ri, ci, table.cols)
        ast.r = Ast.calculateRefs(ast.r)
        ast.c = Ast.calculateRefs(ast.c)
      }
    }
    else if (Ast.isArray(ast)) {
      ast = ast.map(x => Ast.translateAll(workbook, x, t, ri, ci, axis))
    }
    else if (Ast.isString(ast)) {
      return Ast.translateString(workbook, t, ast, ri, ci, axis)
    }
    return ast
  }

  static translateFormula(workbook, ast, table, ri, ci) {
    ast = Ast.translateAll(workbook, ast, table, ri, ci)
    return ast
  }

  static managementBalancePreParsing(arr, data) {
    return arr.map(item => {
      if (typeof item === "string") {
        item = item.replace(/£([a-zA-Z0-9_]+)/g, (match, key) => {
          return key in data ? data[key] : match;
        });
        item = item.replace(/£([a-zA-Z0-9_]+)/g, (match, key) => {
          return key in data ? data[key] : match;
        });
        return item
      }
      return item; // Ritorna il valore originale se non è una stringa
    });
  }

  static isObject(obj) {
    return (typeof obj === 'object') && !Array.isArray(obj)
  }
  static isArray(obj) {
    return (typeof obj === 'object') && Array.isArray(obj)
  }
  static isString(obj) {
    return typeof obj === 'string'
  }
  static isNumber(obj) {
    return typeof obj === 'number'
  }
  static isFunction(obj) {
    if (!obj.op) return false
    return Ast.functions.has(obj.op)
  }
}